<div class="qvs-version-info" [class.qvs-version-info--ebanking]="isEbanking">
  {{ version }}{{ debug ? ' (' + buildNumber + ') ' + ('login.DEBUG' | translate) : undefined }} – {{ buildTime }}
</div>
